import React from 'react';
import update from 'immutability-helper';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button, Table } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { getNameInCurrentLanguage } from 'helpers/intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import PipelineStageData from 'components/layout/pipeline/PipelineStageData';
import PipelineStageTableRow from 'components/layout/pipeline/PipelineStageTableRow';

class PipelineStages extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState({ shownIndex: index === this.state.shownIndex ? null : index });
  };

  addStage = () => {
    let { entity, changeEntity } = this.props;
    let newStage = entity.createValue('stages', []);
    let newValue = entity.getStages().slice();
    newValue.push(newStage);
    let newEntity = { ...entity.updateValue('stages', newValue, []) };

    this.setState({ shownIndex: newValue.length - 1 });

    changeEntity(newEntity);
  };

  handleRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeEntry(index);
  };

  removeEntry = index => {
    let { entity, changeEntity } = this.props;
    let newValue = entity.getStages().slice();
    newValue.splice(index, 1);
    let newEntity = { ...entity.updateValue('stages', newValue, []) };

    if (index < this.state.shownIndex) {
      this.setState(
        prevState => ({ shownIndex: prevState.shownIndex - 1 }),
        () => {
          changeEntity(newEntity);
        }
      );
    } else if (index === this.state.shownIndex) {
      this.setState({ shownIndex: null }, () => {
        changeEntity(newEntity);
      });
    } else {
      changeEntity(newEntity);
    }
  };

  duplicateStage = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    const { entity, changeEntity } = this.props;

    let newStage = entity.createValue('stages', [], entity.copyObject(entity.getStages()[index]));
    let newValue = entity.getStages().slice();
    newValue.splice(index + 1, 0, newStage);
    let newEntity = { ...entity.updateValue('stages', newValue, []) };

    changeEntity(newEntity, () => {
      this.setState({ shownIndex: index + 1 });
    });
  };

  // when dragging, move the stages
  moveStages = (fromIndex, toIndex) => {
    const { entity, changeEntity } = this.props;

    const myData = { stages: entity.getStages().slice() };
    const stage = myData.stages[fromIndex];
    const newData = update(myData, {
      stages: {
        $splice: [[fromIndex, 1], [toIndex, 0, stage]],
      },
    });

    let newEntity = { ...entity.updateValue('stages', newData.stages, []) };

    changeEntity(newEntity);
  };

  render() {
    const { entity, entityLoaded, changeEntity, intl, appIntl, disabled, user } = this.props;
    const messages = intl.messages;

    const { shownIndex } = this.state;

    const columns = [messages.name, messages.properties, messages.actions];
    let tBody = [];
    if (entityLoaded && entity.getStages().length) {
      const stages = entity.getStages();

      tBody = stages.map((stage, i) => {
        const { name } = stage;

        return (
          <PipelineStageTableRow
            key={i}
            messages={messages}
            data={stage}
            shownIndex={shownIndex}
            index={i}
            onClick={() => this.handleClick(i)}
            name={getNameInCurrentLanguage(name, appIntl)}
            doDuplicate={e => this.duplicateStage(e, i)}
            handleRemove={e => this.handleRemoveClick(e, i)}
            hideDetails={() => this.setState({ shownIndex: null })}
            moveStages={this.moveStages}
            user={user}
          />
        );
      });
    }

    if (shownIndex !== null) {
      const data = entity.getStages()[shownIndex];

      // user wants to see a stage form
      tBody.splice(
        shownIndex + 1,
        0,
        <tr key={'details-showing-' + shownIndex} class="row-details">
          <td colSpan={columns.length}>
            <PipelineStageData
              data={data}
              index={shownIndex}
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={changeEntity}
              disabled={disabled}
            />
          </td>
        </tr>
      );
    }

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {entityLoaded ? (
          <div>
            <Row>
              <Col xs={12}>
                <Table responsive hover class="table-detailed">
                  <thead>
                    <tr>
                      {columns.map((column, i) => {
                        return (
                          <th key={i} class={column == messages.actions ? 'text-right' : ''}>
                            {column}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <ReactCSSTransitionGroup
                    transitionName="tablerows"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={1}
                    component="tbody"
                  >
                    {tBody}
                  </ReactCSSTransitionGroup>
                </Table>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div class="m-t-10">
                  <Button onClick={this.addStage}>{messages.add_stage}</Button>
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}
PipelineStages.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(PipelineStages));
